import { call, put, select, takeLatest } from 'redux-saga/effects';

import { Subscription } from '../../../models/subscriptions';
import { postSubscription } from '../../../services/api/subscription';
import * as subscriptionsActions from '../actions';
import * as subscriptionsConstants from '../constants';
import { getSubscriptions } from '../selectors';

const checkDuplicates = (data, payload) => {
  const subscription = new Subscription(payload);
  let result = { isDuplicate: false, message: '' };

  for (let index = 0; index < data.length; index++) {
    const current = data[index];

    result = subscription.isDuplicate(current);
    if (result.isDuplicate) break;
  }

  return result;
};

export function* createSubscription(action) {
  const { payload } = action;

  try {
    if (!payload) throw new Error('Incorrect Subscription.');

    const subscriptions = yield select(getSubscriptions);
    const result = yield call(checkDuplicates, subscriptions, payload);

    if (result?.isDuplicate) {
      throw new Error(result.message);
    }

    const request = Object.keys(payload).reduce((acc, current) => {
      if (payload[current] !== null) {
        return { ...acc, [current]: payload[current] };
      }

      return acc;
    }, {});

    const response = yield call(postSubscription, request);

    if (response?.status === 200) {
      const subscription = new Subscription(response.data.payload);

      yield put(subscriptionsActions.handleCreateSubscriptionSuccess(subscription));

      return;
    }

    throw new Error(response?.statusText);
  } catch (error) {
    yield put(subscriptionsActions.handleCreateSubscriptionFailure(error));
  }
}

export function* watchCreateSubscription() {
  yield takeLatest(subscriptionsConstants.SUBSCRIPTIONS_CREATE_STARTED, createSubscription);
}
